"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUrlWithQuery = createUrlWithQuery;
exports.isDeferredJobResponse = isDeferredJobResponse;
var _queryString = _interopRequireDefault(require("query-string"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function parseUrlParams(query) {
  return _queryString.default.parse(query, {
    arrayFormat: 'bracket'
  });
}
function stringifyUrlParams(params) {
  return _queryString.default.stringify(params, {
    arrayFormat: 'bracket'
  });
}
function createUrlWithQuery(url = '', query) {
  const urlWithQuery = new URL(url);
  if (typeof query === 'object' && query !== null) {
    urlWithQuery.search = stringifyUrlParams({
      ...parseUrlParams(urlWithQuery.search),
      ...query
    });
  }
  return urlWithQuery;
}
function isObject(value) {
  return value !== null && typeof value === 'object';
}
function isDeferredJobResponse(value) {
  return isObject(value) && typeof value.status === 'string' && isObject(value.progress) && typeof value.progress.id === 'string' && Array.isArray(value.progress.links) && value.progress.links.every(link => typeof link === 'string');
}